import { SimTypeId } from '@/@types/simTypeId';

export class SimType {
  public id: SimTypeId;
  public name: string;

  // tslint:disable-next-line:max-line-length
  constructor(id: SimTypeId, name: string) {
    this.id = id;
    this.name = name;
  }
}
